<template>
    <div class="composer-wrapper">
        <div v-if="user.has_access">
            <div class="title-composer">
                <div class="textarea-container">
                    <textarea v-model="title" :placeholder="$t('chat.titlePlaceholder')"></textarea>
                </div>
                <img v-if="showAttach" class="attach-icon icon-img" src="@/assets/icon-images/attach.png" @click="presentActionSheet" />
            </div>

            <div class="message-composer">
                <div class="textarea-container">
                    <textarea v-model="message" @keydown.enter="send" :placeholder="$t('chat.messagePlaceholder')"></textarea>
                </div>
                <ion-input
                    accept="image/*"
                    style="display: none;"
                    type="file"
                    multiple="false"
                    @ionChange="onPictureSelected"
                    ref="pictureInput"
                />
                <ion-input
                    accept="video/*"
                    style="display: none;"
                    type="file"
                    multiple="false"
                    @ionChange="onVideoSelected"
                    ref="videoInput"
                />

                <img @click="send" class="send-icon icon-img" src="@/assets/icon-images/arrow-right.png" />
            </div>
        </div>
        <div v-else>
            <ion-button @click="goToPlans">{{ $t('chat.upgradeMembership') }}</ion-button>
        </div>
    </div>
</template>

<script>
import { validateMessage } from '@/utils/validators.js'
import { mapGetters } from 'vuex'

export default {
    computed: mapGetters(['user']),
    data() {
        return {
            title: '',
            message: '',
            selectedFile: null,
            mediaRecorder: null,
            showAttach: process.env.CORDOVA_PLATFORM !== 'ios'
        }
    },
    methods: {
        send: function(e) {
            e.preventDefault()
            const { error } = validateMessage({
                title: this.title,
                message: this.message
            })
            if (error) {
                this.showAlert(error.details[0].message)
                return
            }
            this.$emit('send', { title: this.title, text: this.message })
            this.title = ''
            this.message = ''
        },
        choosePicture: function() {
            this.$refs.pictureInput.value = null
            this.$refs.pictureInput.children[0].click()
        },
        chooseVideo: function() {
            this.$refs.videoInput.value = null
            this.$refs.videoInput.children[0].click()
        },
        onPictureSelected: function(e) {
            console.log(1)
            if (this.$refs.pictureInput.value == null) return
            console.log(e)
            console.log(e.srcElement.childNodes)
            this.selectedFile = e.srcElement.childNodes[0].files[0]
            const url = URL.createObjectURL(this.selectedFile)
            this.$emit('openMediaPopup', { file: this.selectedFile, url: url, type: 'pic' })
        },
        onVideoSelected: function(e) {
            if (this.$refs.videoInput.value == null) return

            this.selectedFile = e.srcElement.childNodes[0].files[0]
            const url = URL.createObjectURL(this.selectedFile)
            this.$emit('openMediaPopup', { file: this.selectedFile, url: url, type: 'vid' })
        },
        presentActionSheet: function() {
            const buttons =
                process.env.CORDOVA_PLATFORM === 'ios'
                    ? [
                          {
                              text: this.$t('chat.sendPicture'),
                              handler: () => {
                                  this.choosePicture()
                              }
                          },
                          {
                              text: this.$t('chat.sendVideo'),
                              handler: () => {
                                  this.chooseVideo()
                              }
                          },
                          {
                              text: this.$t('master.cancel'),
                              role: 'cancel'
                          }
                      ]
                    : [
                          {
                              text: this.$t('chat.sendPicture'),
                              handler: () => {
                                  this.choosePicture()
                              }
                          },
                          {
                              text: this.$t('chat.sendVoice'),
                              handler: () => {
                                  this.sendAudio()
                              }
                          },
                          {
                              text: this.$t('chat.sendVideo'),
                              handler: () => {
                                  this.chooseVideo()
                              }
                          },
                          {
                              text: this.$t('master.cancel'),
                              role: 'cancel'
                          }
                      ]
            return this.$ionic.actionSheetController
                .create({
                    buttons
                })
                .then(a => a.present())
        },
        sendAudio() {
            this.$emit('openMediaPopup', { type: 'aud' })
        },
        goToPlans() {
            this.$router.push('/plans')
        },
        showAlert: function(string) {
            return this.$ionic.alertController
                .create({
                    message: string,
                    buttons: ['OK']
                })
                .then(a => a.present())
        }
    }
}
</script>

<style lang="scss" scoped>
.icon-img {
    border-radius: 50%;
    float: right;
    margin-right: 10px;
    position: absolute;
    z-index: 1;
}

.textarea-container {
    position: relative;
}

.composer-wrapper {
    display: flex;
    flex-direction: column;
}

.title-composer {
    position: relative;
    background-color: #ebebeb;
    text-align: start;
    flex: 1;

    textarea {
        width: 100%;
        resize: none;
        border: none;
        padding: 6px 6px 0 6px;
        background-color: #ebebeb;
        position: relative;
        top: 7px;
    }

    textarea:focus {
        outline: none !important;
    }

    .attach-icon {
        background: #91bfa2;
        font-size: 20px;
        padding: 2px;
        top: 8px;
        font-size: 25px;
        .icon-inner {
            width: 23px;
        }
    }

    .attach-icon {
        right: 0px;
    }

    .more-icon {
        right: 65px;
        background: transparent;
        padding: 2px;
        top: 10px;
        font-size: 20px;
        color: #bdbdbd;
    }
}

.message-composer {
    overflow: hidden;
    position: relative;
    display: flex;
    background-color: #babfc2;
    flex: 1;
    border-top: 1px solid black;

    .textarea-container {
        width: 80%;

        textarea {
            width: 100%;
            resize: none;
            border: none;
            padding: 6px;
            background-color: #babfc2;
            position: relative;
            top: 7px;
        }
    }

    textarea:focus {
        outline: none !important;
    }

    .send-icon {
        background: #088560;
        font-size: 37px;
        top: 10px;
        right: 0;
        --padding: 3px;
    }
}

#app[dir='rtl'] .message-composer .send-icon {
    right: auto;
    left: 5px;
    transform: rotate(180deg);
}

#app[dir='rtl'] .title-composer .attach-icon {
    right: auto;
    left: 5px;
    transform: rotate(90deg);
}

@media (min-width: 768px) {
    .composer-wrapper {
        font-size: 20px;

        .attach-icon {
            font-size: 30px;
        }
        .more-icon {
            right: 75px;
        }
    }
}
</style>
